import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { focusAreaTypeOptions, organisationTypeOptions } from '../../helper'

export const Community = () => {
  return (
    <>
      <FormField
        id='OrgType'
        label='Organisation type'
        options={organisationTypeOptions}
        type={FormFieldTypes.select}
      />
      <FormField
        id='FocusArea'
        label='Area of focus'
        options={focusAreaTypeOptions}
        type={FormFieldTypes.select}
      />
    </>
  )
}
